module.exports = __webpack_public_path__ + "static/background-28f2f7b0e84569d3b9c4bee79edacb46.png";